import trackAnalyticsEvent from 'utils/trackAnalyticsEvent';

export function shareThis({ dataNetwork, dataUrl, dataTitle } = {}) {
  trackAnalyticsEvent({
    gtagEvent: 'ShareClick',
    mouseflowTag: 'Share',
  });

  let shareThis = typeof window !== 'undefined' && window.__sharethis__;
  if (shareThis) {
    shareThis.share({
      network: dataNetwork,
      url: dataUrl,
      title: dataTitle,
    });
  }
}

export function getUrl() {
  return typeof window !== 'undefined' && window.location.href;
}
